module.exports = __webpack_public_path__ + "static/media/logo.86695d5d.png";